import React from 'react'

import { MagicGrid } from '@caudena/core/ui-kit'

import { CasesDataItem } from '../../types/Case'
import RelatedCaseCard from '../RelatedCaseCard'
import { SnakeToCamelCaseArray } from '@caudena/core/utilsTypes'

interface ClientCasesListProps {
  cases?: SnakeToCamelCaseArray<CasesDataItem>
}

const ClientCasesList: React.FC<ClientCasesListProps> = ({ cases }) => (
  <MagicGrid>
    {cases?.map((caseItem) => (
      <RelatedCaseCard key={caseItem.id} case={caseItem} />
    ))}
  </MagicGrid>
)

export default ClientCasesList
